<template>
  <v-container>
    <h2>ALARMAS ACTIVAS</h2>
    <v-card
      class="mt-4"
      :color="alarms.length > 0 ? 'red' : '#e6ffe6'"
    >
      <!-- Alarmas activas actualmente -->
      <v-container>
        <v-card v-if="alarms.length > 0">
          <v-data-table
            class="active-alarms"
            sort-by="read_timestamp"
            sort-desc
            :headers="headers_active"
            :items="alarms"
            :footer-props="{ 'items-per-page-text': 'Alarmas por página', pageText: '{0}-{1} de {2}' }"
          >
            <template v-slot:[`item.icon`]="">
              <v-icon color="#db0d0d"> mdi-alert </v-icon>
            </template>
            <template v-slot:[`item.read_timestamp`]="{ item }">
              {{ formatTimestamp(item.read_timestamp) }}
            </template>
            <template v-slot:no-results>
              <span>No hay datos para esta búsqueda</span>
            </template>
          </v-data-table>
        </v-card>
        <v-card v-else>
          <v-card-title class="body-1"> Actualmente no se encuentra ninguna alarma activa </v-card-title>
        </v-card>
      </v-container>
    </v-card>

    <!-- Históricos de alarmas -->
    <h2 class="mt-10">HISTÓRICO DE ALARMAS</h2>
    <v-card
      class="mt-4"
      color="#a7ecff"
    >
      <v-container class="text-center">
        <v-card>
          <v-btn
            class="ma-3"
            @click="toggleHistory"
            >{{ show_history ? "Ocultar" : "Consultar" }} históricos</v-btn
          >
          <template v-if="show_history">
            <div class="ml-0 mb-4 mt-2 pl-3 pr-3">
              <v-row class="justify-center">
                <v-col cols="3">
                  <v-menu
                    v-model="initTimestampInput"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="initTimestamp"
                        label="Fecha inicio"
                        prepend-icon="mdi-calendar"
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="initTimestamp"
                      @input="initTimestampInput = false"
                      no-title
                      scrollable
                      first-day-of-week="1"
                      locale="es-ES"
                    ></v-date-picker>
                  </v-menu>
                </v-col>

                <v-col cols="3">
                  <v-menu
                    v-model="endTimestampInput"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="endTimestamp"
                        label="Fecha fin"
                        prepend-icon="mdi-calendar"
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="endTimestamp"
                      @input="endTimestampInput = false"
                      no-title
                      scrollable
                      first-day-of-week="1"
                      locale="es-ES"
                    ></v-date-picker>
                  </v-menu>
                </v-col>

                <v-col cols="3">
                  <v-text-field
                    v-model="description"
                    label="Descripción"
                    type="string"
                    hide-details
                  >
                  </v-text-field>
                </v-col>

                <v-col
                  cols="3"
                  style="align-content: center"
                  class="pb-5"
                >
                  <v-btn
                    @click="getHistory"
                    color="#a7ecff"
                    rounded
                  >
                    <v-icon>mdi-magnify</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </div>

            <!-- Tabla de alarmas -->
            <v-data-table
              :headers="headers_history"
              :items="alarm_history"
              :search="search"
              :loading="loading_history"
              no-data-text="No se han encontrado datos"
              :footer-props="{ 'items-per-page-text': 'Alarmas por página', pageText: '{0}-{1} de {2}' }"
            >
              <template v-slot:[`item.activation_timestamp`]="{ item }">
                {{ formatTimestamp(item.activation_timestamp) }}
              </template>
              <template v-slot:[`item.deactivation_timestamp`]="{ item }">
                {{ formatTimestamp(item.deactivation_timestamp) || "ACTUALMENTE ACTIVA" }}
              </template>
              <template v-slot:no-results>
                <span>No hay datos para esta búsqueda</span>
              </template>
            </v-data-table>
          </template>
        </v-card>
      </v-container>
    </v-card>

    <!-- Históricos de alarmas de analizadores -->
    <h2 class="mt-10">HISTÓRICO DE ALARMAS ANALIZADORES</h2>
      <v-card
        class="mt-4"
        color="#a7ecff"
      >
        <v-container class="text-center">
          <v-card>
            <v-btn
              class="ma-3"
              @click="toggleHistoryAnalizadores"
              >{{ show_history_analizadores ? "Ocultar" : "Consultar" }} históricos</v-btn
            >
            <template v-if="show_history_analizadores">
              <div class="ml-0 mb-4 mt-2 pl-3 pr-3">
                <v-row class="justify-center">
                  <v-col cols="3">
                    <v-menu
                      v-model="initTimestampInputAnalizadores"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="initTimestampAnalizadores"
                          label="Fecha inicio"
                          prepend-icon="mdi-calendar"
                          dense
                          outlined
                          v-bind="attrs"
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="initTimestampAnalizadores"
                        @input="initTimestampInputAnalizadores = false"
                        no-title
                        scrollable
                        first-day-of-week="1"
                        locale="es-ES"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>

                  <v-col cols="3">
                    <v-menu
                      v-model="endTimestampInputAnalizadores"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="endTimestampAnalizadores"
                          label="Fecha fin"
                          prepend-icon="mdi-calendar"
                          dense
                          outlined
                          v-bind="attrs"
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="endTimestampAnalizadores"
                        @input="endTimestampInputAnalizadores = false"
                        no-title
                        scrollable
                        first-day-of-week="1"
                        locale="es-ES"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>

                  <v-col cols="3">
                    <v-select
                      v-model="id_alarm"
                      :items="alarmas_analizadores"
                      item-text="name"
                      item-value="id"
                      label="Alarma"
                      dense
                      outlined
                      hide-details
                    ></v-select>
                  </v-col>


                  <v-col
                    cols="3"
                    style="align-content: center"
                    class="pb-5"
                  >
                    <v-btn
                      @click="getHistoryAnalizadores"
                      color="#a7ecff"
                      rounded
                    >
                      <v-icon>mdi-magnify</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
              </div>

              <!-- Tabla de alarmas -->
              <v-data-table
                :headers="headers_history_analizadores"
                :items="alarm_history_analizadores"
                :search="search"
                :loading="loading_history_analizadores"
                no-data-text="No se han encontrado datos"
                :footer-props="{ 'items-per-page-text': 'Alarmas por página', pageText: '{0}-{1} de {2}' }"
              >
                <template v-slot:[`item.created_at`]="{ item }">
                  {{ formatTimestamp(item.created_at) }}
                </template>
                <!-- <template v-slot:[`item.deactivation_timestamp`]="{ item }">
                  {{ formatTimestamp(item.deactivation_timestamp) || "ACTUALMENTE ACTIVA" }}
                </template> -->
                <template v-slot:no-results>
                  <span>No hay datos para esta búsqueda</span>
                </template>
              </v-data-table>
            </template>
          </v-card>
        </v-container>
      </v-card>

    <template v-if="isAdmin() || isUser()">
      <h2 class="mt-10">CONFIGURACIÓN DE ALARMAS</h2>
      <v-card
        class="mt-4"
        color="#a7ecff"
      >
        <v-container class="text-center">
          <v-card>
            <v-btn
              class="ma-3"
              @click="toggleConfiguration"
            >
              {{ show_configuration ? "Ocultar" : "Consultar" }} configuración
            </v-btn>
            <template v-if="show_configuration">
              <div class="ml-0 mb-4 mt-2 pl-3 pr-3">
                <v-row class="justify-center">
                  <v-col cols="3">
                    <v-select
                      :items="machines"
                      v-model="configuration_filter_machine"
                      label="Máquina"
                      item-text="name"
                      item-value="id"
                    ></v-select>
                  </v-col>

                  <v-col cols="6">
                    <v-text-field
                      v-model="configuration_filter_description"
                      label="Descripción"
                      type="string"
                      hide-details
                    >
                    </v-text-field>
                  </v-col>

                  <v-col
                    cols="3"
                    style="align-content: center"
                    class="pb-5"
                  >
                    <v-btn
                      @click="getConfiguration"
                      color="#a7ecff"
                      rounded
                    >
                      <v-icon>mdi-magnify</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
              </div>

              <!-- Tabla de alarmas -->
              <v-data-table
                :headers="headers_configuration"
                :items="alarm_configuration"
                :loading="loading_configuration"
                no-data-text="No se han encontrado datos"
                :footer-props="{ 'items-per-page-text': 'Alarmas por página', pageText: '{0}-{1} de {2}' }"
              >
                <template v-slot:no-results>
                  <span>No hay datos para esta búsqueda</span>
                </template>
                <template v-slot:[`item.actions`]="{ item }">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        x-small
                        fab
                        color="#a7ecff"
                        elevation="0"
                        v-bind="attrs"
                        v-on="on"
                        @click="editAlarm(item)"
                      >
                        <v-icon small>mdi-pencil</v-icon>
                      </v-btn>
                    </template>
                    <span>Editar</span>
                  </v-tooltip>
                </template>
              </v-data-table>
            </template>
          </v-card>
        </v-container>
      </v-card>
      <v-dialog
        v-model="show_alarm_configuration_dialog"
        persistent
        max-width="800px"
      >
       <v-card>
          <!-- Barra de carga -->
          <v-progress-linear
            v-if="loading_update_alarm"
            indeterminate
            color="primary"
            height="4"
          />

          <!-- Contenido del formulario -->
          <AlarmConfigurationForm
            :incomingAlarm="updating_alarm_configuration"
            :notificationTypes="notification_types"
            @close="saveAlarm"
            @cancel="show_alarm_configuration_dialog = false"
          />
        </v-card>
      </v-dialog>
    </template>
    
    <template v-if="isAdmin() || isUser()">
      <h2 class="mt-10">CONFIGURACIÓN DE ALARMAS DEL ANALIZADOR</h2>
      <v-card
        class="mt-4"
        color="#a7ecff"
      >
        <v-container class="text-center">
          <v-card>
            <v-btn
              class="ma-3"
              @click="toggleConfigurationAnalizadores"
            >
              {{ show_configuration_analizadores ? "Ocultar" : "Consultar" }} configuración analizadores
            </v-btn>
            <template v-if="show_configuration_analizadores">
              <!-- Tabla de alarmas -->
              <v-data-table
                :headers="headers_configuration_analizadores"
                :items="alarm_configuration_analizadores"
                :loading="loading_configuration_analizadores"
                no-data-text="No se han encontrado datos"
                :footer-props="{ 'items-per-page-text': 'Alarmas por página', pageText: '{0}-{1} de {2}' }"
              >
                <template v-slot:no-results>
                  <span>No hay datos para esta búsqueda</span>
                </template>
                <template v-slot:[`item.actions`]="{ item }">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        x-small
                        fab
                        color="#a7ecff"
                        elevation="0"
                        v-bind="attrs"
                        v-on="on"
                        @click="editAlarmAnalizador(item)"
                      >
                        <v-icon small>mdi-pencil</v-icon>
                      </v-btn>
                    </template>
                    <span>Editar</span>
                  </v-tooltip>
                </template>
              </v-data-table>
            </template>
          </v-card>
        </v-container>
      </v-card>
      <v-dialog
        v-model="show_analizador_alarm_configuration_dialog"
        persistent
        max-width="800px"
      >
        <v-card>
          <v-progress-linear
            v-if="loading_update_alarm_analizator"
            indeterminate
            color="primary"
            height="4"
          />
          <AnalizadorAlarmConfiguration
            :incomingAlarm="updating_alarm_configuration"
            :notificationTypes="notification_types"
            @close="saveAnalizadorAlarm"
            @cancel="show_analizador_alarm_configuration_dialog = false"
          ></AnalizadorAlarmConfiguration>
        </v-card>
      </v-dialog>
    </template>
  </v-container>
</template>

<script>
import moment from "moment";
import "moment-timezone";

import AlarmConfigurationForm from "@/components/forms/AlarmConfigurationForm.vue";
import AlarmsParameters from "@/components/utils/AlarmsParameters.vue";
import AnalizadorAlarmConfiguration from "@/components/forms/AnalizadorAlarmConfigurationForm.vue"

import { mapGetters, mapActions, mapState } from "vuex";

export default {
  components: {
    AlarmConfigurationForm,
    AlarmsParameters,
    AnalizadorAlarmConfiguration
  },

  data() {
    return {
      load_interval: null,

      load_alarms: false,

      alarm_config: false,

      alarms: [],
      alarm_history: [],
      alarm_configuration: [],
      alarm_configuration_analizadores: [],
    
      headers_active: [
        { text: "", value: "icon" },
        { text: "ID", value: "alarm_id" },
        { text: "Descripción", value: "description" },
        { text: "Activado", value: "read_timestamp" },
      ],
      headers_history: [
        { text: "ID", value: "alarm_id" },
        { text: "Descripción", value: "description" },
        { text: "Activado", value: "activation_timestamp" },
        { text: "Desactivado", value: "deactivation_timestamp" },
      ],
      headers_history_analizadores: [
        { text: "ID", value: "id" },
        { text: "Descripción", value: "alarma" },
        { text: "Activado", value: "created_at" },
      ],
      headers_configuration: [
        { text: "Máquina", value: "plc_name" },
        { text: "ID", value: "alarm_id" },
        { text: "ID HMI", value: "hmi_alarm_id" },
        { text: "Descripción", value: "text_description" },
        { text: "Tipo de notificación", value: "notification_type_description" },
        { text: "", value: "actions" },
      ],
      headers_configuration_analizadores: [
        { text: "ID", value: "id" },
        { text: "Descripción", value: "name" },
        { text: "Alarma activa", value: "activo" },
        { text: "Tipo de notificación", value: "description" },
        { text: "", value: "actions" },
      ],

      search: null,

      description: "",
      initTimestamp: moment(Date.now()).subtract(1, "days").format("YYYY-MM-DD"),
      endTimestamp: moment(Date.now()).format("YYYY-MM-DD"),
      initTimestampInput: false,
      endTimestampInput: false,

      next_action: "Consultar",
      show_history: false,
      loading_history: false,

      show_configuration: false,
      loading_configuration: false,
      loading_configuration_analizadores: false,
      machines: [],
      notification_types: [],
      configuration_filter_machine: null,
      configuration_filter_description: "",
      show_alarm_configuration_dialog: false,
      show_analizador_alarm_configuration_dialog: false,
      updating_alarm_configuration: null,

      alarmas_analizadores : [
        {name: "Corriente", id: 3},
        {name: "Tensión", id: 2},
      ],

      show_configuration_analizadores: false,
      show_history_analizadores: false,
      initTimestampAnalizadores: moment(Date.now()).subtract(1, "days").format("YYYY-MM-DD"),
      endTimestampAnalizadores: moment(Date.now()).format("YYYY-MM-DD"),
      initTimestampInputAnalizadores: false,
      endTimestampInputAnalizadores: false,
      loading_history_analizadores: false,
      alarm_history_analizadores: [],
      id_alarm: null,

      loading_update_alarm:false,
      loading_update_alarm_analizator: false,

    };
  },
  computed: {
    ...mapState("nodered", ["client"]),
  },

  methods: {
    ...mapGetters(["isAdmin", "isUser"]),
    ...mapActions(["getData", "putData", "getDataFlask"]),

    async toggleHistory() {
      this.show_history = !this.show_history;
      if (this.show_history) await this.getHistory();
    },
    async toggleHistoryAnalizadores(){
      this.show_history_analizadores = !this.show_history_analizadores;
      if (this.show_history_analizadores) await this.getHistoryAnalizadores();
    },

    formatTimestamp(timestamp) {
      if (timestamp != null && timestamp != undefined && timestamp.length > 0) {
        // return moment(timestamp).tz("Europe/Madrid").format("YYYY-MM-DD HH:mm:ss");
        return moment.utc(timestamp).format("YYYY-MM-DD HH:mm:ss");
      } else return null;
    },

    async getHistory() {
      this.loading_history = true;
      const params = {
        initTimestamp: new Date(`${this.initTimestamp} 00:00:00`).toISOString(),
        endTimestamp: new Date(`${this.endTimestamp} 23:59:59`).toISOString(),
        description: this.description,
      };
      const { alarms } = await this.getData({ path: "alarms/history", params });
      this.alarm_history = alarms;
      this.loading_history = false;
    },
    async getHistoryAnalizadores(){
      this.loading_history_analizadores = true;
      const params = {
        initTimestamp: new Date(`${this.initTimestampAnalizadores} 00:00:00`).toISOString(),
        endTimestamp: new Date(`${this.endTimestampAnalizadores} 23:59:59`).toISOString(),
        id_alarm: this.id_alarm,
      };
      console.log("historico analizadores", params);
      const { alarms } = await this.getData({ path: "alarms/history/analizadores", params });
      console.log(alarms);
      this.alarm_history_analizadores = alarms;
      this.loading_history_analizadores = false;
    },

    async toggleConfigurationAnalizadores(){
      this.show_configuration_analizadores = !this.show_configuration_analizadores;
      if (this.show_configuration_analizadores) await this.getConfigurationAnalizadores();
    },

    async getConfigurationAnalizadores(){
      this.loading_configuration_analizadores = true;
      const { analizadores, notification_types } = await this.getData({ path: "alarms/analizadores" });
      this.notification_types = notification_types;
      this.alarm_configuration_analizadores = analizadores;
      this.loading_configuration_analizadores = false;
    },

    async toggleConfiguration() {
      this.show_configuration = !this.show_configuration;
      if (this.show_configuration) await this.getConfiguration();
    },

    async getConfiguration() {
      this.loading_configuration = true;
      const params = {
        ...(this.configuration_filter_machine ? { plc_id: this.configuration_filter_machine } : {}),
        ...(this.configuration_filter_description?.length > 0
          ? { description: this.configuration_filter_description }
          : {}),
      };

      const { configuration, plcs, notification_types } = await this.getData({ path: "alarms/configuration", params });
      this.alarm_configuration = configuration;
      if (!Object.keys(params)?.length) {
        this.machines = [...plcs, { id: null, name: "TODAS" }];
        this.notification_types = notification_types;
      }

      this.loading_configuration = false;
    },

    editAlarm(alarm_configuration) {
      this.updating_alarm_configuration = Object.assign({}, alarm_configuration);
      this.show_alarm_configuration_dialog = true;
    },
    editAlarmAnalizador(alarm_configuration) {
      this.updating_alarm_configuration = Object.assign({}, alarm_configuration);
      this.show_analizador_alarm_configuration_dialog = true;
    },

    async saveAlarm({ alarm_id, ...alarm_configuration }) {
      try {
        this.loading_update_alarm = true;
        await this.putData({ path: "alarms", params: alarm_id, body: { ...alarm_configuration } });
        // const [{ alarms }, { configuration }] = await Promise.all([
        //   this.getData({ path: "alarms" }),
        //   // this.getData({ path: "alarms/configuration" }),
        // ]);
        // const alarms = await this.getData({ path: "alarms" });
        // this.alarms = alarms;
        this.getConfiguration();
        
        //enviamos al python flask para actualizar las alarmas
        // const actFlask = await this.getDataFlask("logica_historicos/alarmas");
        // console.log(actFlask);
        // this.doPublish({
        //   topic: "UPDATE_VARIABLES",
        //   message: { update: true },
        // });
        this.loading_update_alarm = false;
        this.show_alarm_configuration_dialog = false;
      } catch (error) {
        console.error(error);
      }
    },

    async saveAnalizadorAlarm(alarm){
      try{
        this.loading_update_alarm_analizator = true;
        await this.putData({ path: "alarms/analizadores_update", body: alarm });
        await this.getConfigurationAnalizadores();
        this.loading_update_alarm_analizator = false;
        this.show_analizador_alarm_configuration_dialog = false;

      } catch(e){
        console.error("Error al actualizar alarma:", e);
      }
    },
    async getActiveAlarms(){
      try{
        this.load_alarms = false;
        const { alarms } = await this.getData({ path: "alarms/active" });
        this.alarms = alarms;
      } catch(e){
        console.error("error al recoger datos de alarmas:", e);
      } finally {
        this.load_alarms = true;
      }
    }
  },
  async mounted() {
    await this.getActiveAlarms();
    this.load_interval = setInterval(async () => {
      await this.getActiveAlarms();
      // console.log("actualizamos alarmas activas");
    }, 60000);
  },
  beforeDestroy() {
    if (this.alarmInterval) {
      clearInterval(this.alarmInterval);
    }
  },
};
</script>
